function getNetworkName(networkId, networks) {
  const network = networks.find((network) => network._id === networkId);
  return network ? network.name : "-";
}

export { getNetworkName };
